import { Component } from '@angular/core';

@Component({
  selector: 'app-imprint',
  template: '<lib-imprint></lib-imprint>'
})
export class ImprintComponent {
}
